import BasePage from "@Scripts/Pages/BasePage";

export default class TrainingEventList extends BasePage {
    public static async init() {
        await super.init();

        this.setSearch();
    }

    private static setSearch() {
        let typeFilters = document.getElementsByName("typeFilter"),
            selectedType = null,
            allTypesFilter = document.getElementById("AllTypesFilterButton"),
            self = this;

        if (typeFilters != null && typeFilters.length != 0) {
            for (let i = 0; i < typeFilters.length; i++) {
                if (typeFilters[i].hasAttribute("data-selected")) {
                    selectedType = typeFilters[i].getAttribute("data-value");
                }

                typeFilters[i].addEventListener("click", function () {
                    selectedType = typeFilters[i].getAttribute("data-value");
                    self.setSearchRequest(selectedType);
                });
            }
        }

        if (allTypesFilter) {
            allTypesFilter.addEventListener("click", function () {
                self.setSearchRequest(null);
            });
        }
    }

    private static setSearchRequest(selectedType: any) {
        let filters = [],
            filterCount = 0,
            queryString = "";

        if (selectedType) {
            filters.push("typeFilter=" + selectedType);
            filterCount++;
        }

        if (filterCount !== 0) {
            queryString = filters.join("&");
            window.location.href = (<any>window).App.routes.Training_EventList + "?" + queryString;
        } else {
            window.location.href = (<any>window).App.routes.Training_EventList;
        }
    }
}